import { useContext } from "react";
import { ClinicaContext } from "../../../../context/clinica-context";
import PdfOrcamentoSegurado from "./PdfOrcamentoSegurado";

const MODELOS = {
  modelo1: PdfOrcamentoSegurado,
};

function PdfOrcamentoSeguradoWrapper({ showSinglePage, orcamentoData }) {
  const { configuracoes } = useContext(ClinicaContext);
  const modeloKey =
    configuracoes?.configuracoes?.modelosDocumentos?.orcamento || "modelo1";
  const Modelo = MODELOS[modeloKey] ?? PdfOrcamentoSegurado;

  return (
    <div>
      <Modelo orcamentoData={orcamentoData} showSingleP={showSinglePage} />
    </div>
  );
}

export default PdfOrcamentoSeguradoWrapper;
